





















































































































import  { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import { placeModule } from "@/store/modules/place";
import { communityHistoryModule } from '@/store/modules/communityHistory';
import { PlaceOptions } from '@/types/place';
import { COMMUNITYLIST } from '@/utils/store-util';
@Component
export default class CommunityHistory extends Vue {
    public placeoptions: PlaceOptions = {
        placefc: null,
        page: 1
    };
    public queryDate = (() => {
        const d = new Date();
        d.setMonth(d.getMonth() - 1);
        return d.toISOString().substring(0, 7);
    })();
    public menu = false;
    public tabs = null;
    public placeObject = {
        branch_name: "北港灣內",
        branch_type: "社區",
        index: 1,
        netown_device_number: "ABOT19Y255",
        shortcode: "BG"
    };
    public headers = [
        {
            text: "統計時間",
            left: true,
            sortable: true,
            value: "measure_at"
        },
        { text: "總人數", sortable: true, value: "data.total" ,align:'right' },
        { text: "血壓正常人數", sortable: true, value: "data.bp_green",align:'right' },
        { text: "血壓異常人數", sortable: true, value: "data.bp_red",align:'right' },
        { text: "血壓低頻率人數", sortable: true, value: "data.bp_blue",align:'right' },
        { text: "收縮壓平均", sortable: true, value: "data.systolic_avg",align:'right' },
        { text: "舒張壓平均", sortable: true, value: "data.diastolic_avg",align:'right' },
        { text: "握力正常人數", sortable: true, value: "data.grip_green",align:'right' },
        { text: "握力異常人數", sortable: true, value: "data.grip_red",align:'right' },
        { text: "握力低頻率人數", sortable: true, value: "data.grip_blue",align:'right' },
        { text: "握力值平均", sortable: true, value: "data.grip_avg",align:'right' },
        { text: "體適能正常人數", sortable: true, value: "data.frailty_green",align:'right' },
        { text: "體適能異常人數", sortable: true, value: "data.frailty_red",align:'right' },
        { text: "體適能低頻率人數", sortable: true, value: "data.frailty_blue",align:'right' },
        { text: "走路值平均", sortable: true, value: "data.walktime_avg",align:'right' },
        { text: "坐站值平均", sortable: true, value: "data.ftsst_avg",align:'right' },
        { text: "BMI正常人數", sortable: true, value: "data.bmi_green",align:'right' },
        { text: "BMI異常人數", sortable: true, value: "data.bmi_red",align:'right' },
        { text: "BMI低頻率人數", sortable: true, value: "data.bmi_blue",align:'right' },
        { text: "BMI值平均", sortable: true, value: "data.bmi_avg",align:'right' },
    ];
    public headersTab2 = [
        {
            text: "地區",
            left: true,
            sortable: true,
            value: "TOWNNAME"
        },
        { text: "總人數", sortable: true, value: "total",align:'right' },
        { text: "血壓正常人數", sortable: true, value: "bp_green",align:'right' },
        { text: "血壓異常人數", sortable: true, value: "bp_red",align:'right' },
        { text: "血壓低頻率人數", sortable: true, value: ".bp_blue",align:'right' },
        { text: "收縮壓平均", sortable: true, value: "systolic_avg",align:'right' },
        { text: "舒張壓平均", sortable: true, value: "diastolic_avg",align:'right' },
        { text: "握力正常人數", sortable: true, value: "grip_green",align:'right' },
        { text: "握力異常人數", sortable: true, value: "grip_red",align:'right' },
        { text: "握力低頻率人數", sortable: true, value: "grip_blue",align:'right' },
        { text: "握力值平均", sortable: true, value: "grip_avg",align:'right' },
        { text: "體適能正常人數", sortable: true, value: "frailty_green",align:'right' },
        { text: "體適能異常人數", sortable: true, value: "frailty_red",align:'right' },
        { text: "體適能低頻率人數", sortable: true, value: "frailty_blue",align:'right' },
        { text: "走路值平均", sortable: true, value: "walktime_avg",align:'right' },
        { text: "坐站值平均", sortable: true, value: "ftsst_avg",align:'right' },
        { text: "BMI正常人數", sortable: true, value: "bmi_green",align:'right' },
        { text: "BMI異常人數", sortable: true, value: "bmi_red",align:'right' },
        { text: "BMI低頻率人數", sortable: true, value: "bmi_blue",align:'right' },
        { text: "BMI值平均", sortable: true, value: "bmi_avg",align:'right' },
    ];
    public lastPlace = null;
    public lastDate = null;
    public tab2Loaded = false;
    get place() {
        const place2display = [];
        placeModule.place.forEach((element)=>{
            if (COMMUNITYLIST.includes(`${element['shortcode']}-${element['index']}`)){
                place2display.push(element);
            }
        })
        return place2display;
    }
    get loading() {
        return communityHistoryModule.loading;
    }
    get loadingTab2(){
        return communityHistoryModule.loadingTab2;
    }
    get items(){
        return communityHistoryModule.items;
    }
    get itemsTab2(){
        return communityHistoryModule.itemsTab2;
    }
    get pagination(){
        return  communityHistoryModule.pagination;
    }
    get totalRecords() {
        return communityHistoryModule.totalRecords;
    }


    placeItemValue(item){
        return `${item.shortcode}-${item.index}`;
    }
    async created() {
        await placeModule.placeList();
        await this.updateTableData();
    }

    async updateTableData() {
      if (!this.loading){
        if(this.placeObject.branch_name !== this.lastPlace){
          this.placeoptions.page = 1;
          this.lastPlace = this.placeObject.branch_name;
        }
      }
      this.placeoptions.placefc = `${this.placeObject.shortcode}-${this.placeObject.index}`;
      await communityHistoryModule.getPlace(this.placeoptions);
    }

    async updateTableDataTab2(){
      if(!this.loadingTab2){
        this.lastDate = this.queryDate;
      }
      const [year, month] = this.queryDate.split('-').map(Number);
      const apiDate = month === 12 ? `${year + 1}-01` : `${year}-${String(month + 1).padStart(2, '0')}`; // +1 month: data stored under execution month
      console.log('[Tab2] queryDate:', this.queryDate, '→ apiDate:', apiDate);
      await communityHistoryModule.getPlaceByDate(apiDate);
    }

    @Watch("tabs", { immediate: false })
    onTabChange(newTab: number) {
        if (newTab === 1 && !this.tab2Loaded) {
            this.tab2Loaded = true;
            this.updateTableDataTab2();
        }
    }

    @Watch("placeObject.branch_name",{immediate:false, deep:false})
    watchPlace(newVal, oldVal) {
      if (newVal !== this.lastPlace) {
        this.updateTableData();
      }
    }

    // @Watch("queryDate",{immediate:false, deep:false})
    // watchDate(newVal, oldVal) {
    //     if (newVal !== this.lastDate){
    //       this.updateTableDataTab2();
    //     }
    // }
}
